import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'ramda/src/isEmpty';
import Routes from 'apps/portal/routes.erb';
import { getPaginationSlice, getJobType } from 'helpers/shared';
import { MapMarkerAltIcon, SuitcaseIcon } from 'shared/icons';
import OverlaySpinner from '@fountain/ui-kit/components/overlay-spinner';
import Button from '@fountain/ui-kit/components/button';

import './styles.pcss';

export default class OpeningsDirectoryIndexOpenings extends PureComponent {
  static propTypes = {
    accountSlug: PropTypes.string.isRequired,
    ax: PropTypes.bool,
    clearAllFilters: PropTypes.func.isRequired,
    openings: PropTypes.arrayOf(PropTypes.shape({
      employmentType: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      locationAddress: PropTypes.string,
      locationName: PropTypes.string,
      title: PropTypes.string,
    })).isRequired,
    pagination: PropTypes.shape({
      currentPage: PropTypes.number,
      nextPage: PropTypes.number,
      perPage: PropTypes.number,
      totalCount: PropTypes.number,
      totalPages: PropTypes.number,
    }).isRequired,
    ui: PropTypes.shape({
      isLoading: PropTypes.bool,
    }).isRequired,
    urlParams: PropTypes.string.isRequired,
    translations: PropTypes.shape({
      view: PropTypes.string,
      cityOrZipCodePlaceholder: PropTypes.string,
      clearAllSelections: PropTypes.string,
      jobOpenings: PropTypes.string,
      location: PropTypes.string,
      positions: PropTypes.string,
      radius: PropTypes.string,
      selectPosition: PropTypes.string,
      nonePositions: PropTypes.string,
      showRemoteJobsOnly: PropTypes.string,
      locationIsRequired: PropTypes.string,
      noResultsInRadius: PropTypes.string,
      useCurrentLocation: PropTypes.string,
      hour: PropTypes.string,
    }).isRequired,
    embeddable: PropTypes.bool,
  }

  static defaultProps = {
    ax: false,
    embeddable: false,
  }

  _getOpeningLink = (opening) => {
    if (!opening.id) {
      return null;
    }

    const { urlParams, accountSlug } = this.props;
    const baseUrl = Routes.apply_with_form_path(accountSlug, opening.toParam);

    const params = new URLSearchParams(urlParams);

    if (!params.has('brand_id')) {
      params.set('brand_id', 'all');
    } else {
      params.delete('brand_id');
    }

    const finalParams = params.toString();
    return `${baseUrl}${finalParams ? '?' : ''}${finalParams}`;
  }

  render() {
    const {
      ax,
      clearAllFilters,
      embeddable,
      openings,
      pagination,
      ui,
      translations: {
        view, clearAllSelections, jobOpenings, noResultsInRadius,
      },
    } = this.props;

    const button = ax ? (
      <Button className="openings__list-item-action-button ax-button" size="small">
        <span>{ view }</span>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path d="M6.434 12.27l3.445-3.445-3.445-3.445 1.055-1.055 4.5 4.5-4.5 4.5z" />
        </svg>
      </Button>
    ) : (
      <Button className="openings__list-item-action-button" size="small">
        { view }
      </Button>
    );

    return (
      <OverlaySpinner className="openings" show={ui.isLoading}>
        {(isEmpty(openings) && !ui.isLoading) ? (
          <div className="openings__empty-message">
            <div className="openings__empty-message-content">
              <p>
                {noResultsInRadius}
                {
                  // eslint-disable-next-line
                  <a className="openings__empty-message-content-row-action" onClick={clearAllFilters}>
                    {clearAllSelections}
                  </a>
                }
                .
              </p>
            </div>
          </div>
        ) : (
          <Fragment>
            {pagination.totalCount > 1 && !ax && (
              <p className="openings__slice">
                {getPaginationSlice(pagination)} <b>{pagination.totalCount} {jobOpenings}</b>
              </p>
            )}

            <ul className="openings__list">
              {openings.map(opening => (
                <li className="openings__list-item" key={opening.id}>
                  <a className="openings__list-item-link" target={embeddable ? '_blank' : undefined} rel={embeddable ? 'noreferrer' : undefined} href={this._getOpeningLink(opening)}>
                    <div className="openings__list-item-content">
                      <h5 className="openings__list-item-content-title">
                        {opening.title}
                      </h5>
                      <p className="openings__list-item-content-details">
                        {opening.locationName && (
                          <span className="openings__list-item-content-details-item">
                            {opening.locationName}
                          </span>
                        )}

                        <span className="openings__list-item-content-details-item">
                          <MapMarkerAltIcon className="openings__list-item-content-details-icon" />
                          {opening.locationAddress || 'Remote'}
                        </span>
                        {opening.jobType && (
                          <span className="openings__list-item-content-details-item">
                            <SuitcaseIcon className="openings__list-item-content-details-icon" />
                            {getJobType(opening.jobType)}
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="openings__list-item-action">
                      {button}
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </Fragment>
        )}
      </OverlaySpinner>
    );
  }
}
